module.exports = __webpack_public_path__ + "static/media/OnSiteMessageAssistance.8fe78055.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/OnSiteMessageAssistance.svg
// module id = 2605
// module chunks = 0